export enum RoutePreviewReason {
  ROUTE_TIMES_CHANGED = 'ROUTE_TIMES_CHANGED',
  ROUTE_STOPS_CHANGED = 'ROUTE_STOPS_CHANGED',
  TRIP_MAX_TIME_EXCEEDED = 'TRIP_MAX_TIME_EXCEEDED',
  BOOKING_PATH_DELETED = 'BOOKING_PATH_DELETED',
}
